// Allowed values for recordAppEventCounter only — not used by logCustomEvent.
export const AppEventCounter = {
    MetricNames: {
        DIGITAL_EVENT_V1: "digital_event_v1",
    },
    Events: {
        VIN_NOT_FOUND: "vin_not_found",
        SHOW_ALERT: "show_alert",
        SCHEDULE_MOBILE_NOT_AVAILABLE: "schedule_mobile_not_available",
        SCHEDULE_INSHOP_NOT_AVAILABLE: "schedule_inshop_not_available",
        SCHEDULE_NO_SHOPS_NEARBY: "schedule_no_shops_nearby",
        SCHEDULE_NO_TIMESLOTS: "schedule_no_timeslots",
        SCHEDULE_NO_TIMESLOTS_MOBILE: "schedule_no_timeslots_mobile",
        SCHEDULE_NO_TIMESLOTS_INSHOP: "schedule_no_timeslots_inshop",
    },
    Labels: {
        BY_VIN_NUMBER: "by_vin_number",
        BY_LICENSE_PLATE: "by_license_plate",
        BY_ADDRESS: "by_address",
        BY_IMAGE: "by_image",
        VEHICLE_IS_NOT_SERVICED: "vehicle_is_not_serviced",
        BIGTRUCK_ZIP_IS_NOT_SERVICED: "bigtruck_zip_is_not_serviced",
        ZIP_NOT_FOUND: "zip_not_found",
        ZIP_NOT_SERVICED: "zip_not_serviced",
        // NOTE: Might be worth standardizing the timeslot labels to fit the naming conventions of the other labels here. For now, though, I am adding them exactly as they are written in CASH-3143.
        TIMESLOT_0_T0_6_DAYS: "0-6 days",
        TIMESLOT_7_TO_13_DAYS: "7-13 days",
        TIMESLOT_14_PLUS_DAYS: "14+ days",
    },
    Statuses: {
        OK: "200",
        BAD_REQUEST: "400",
        NOT_FOUND: "404",
        SERVER_ERROR: "500",
        UNKNOWN: "unk",
    },
};
